import {Types} from './PerformanceEvaluationContext'


const ModalReducer = (state:any, action:any) => {
    const {payload,type} = action;
    
    switch(type){
        case Types.CREATE_PERFORMANCE_EVALUATION:
            return {
            ...state,
            _id:payload._id,
            item:payload.item,
            modalPerformanceEvaluation:true
        }
       
        case Types.CLOSE_PERFORMANCE_EVALUATION:
         return{
            ...state,
            _id:'',
            item: null,
            modalPerformanceEvaluation:false
        }

        case Types.DELETE_PERFORMANCE_EVALUATION:
            return{
                ...state,
                _id:payload._id,
                modalEliminaPerformanceEvaluation:true
            }

        case Types.CLOSE_DELETE_PERFORMANCE_EVALUATION:
                 return{
            ...state,
            _id:'',
            modalEliminaPerformanceEvaluation:false
        }
    

        case Types.CREATE_COMPETENCE_EVALUATION:
        return {
            ...state,
            _id:payload._id,
            modalCompetenceEvaluation:true
        }
    
        case Types.CLOSE_COMPETENCE_EVALUATION:
                return{
            ...state,
            _id:'',
            modalCompetenceEvaluation:false
        }   

        case Types.DELETE_COMPETENCE_EVALUATION:
        return{
            ...state,
            _id:payload._id,
            eliminaCompetencePerformanceEvaluation:true
        }

        case Types.CLOSE_DELETE_COMPETENVE_EVALUATION:
            return{
            ...state,
            _id:'',
            eliminaCompetencePerformanceEvaluation:false
        }   

        case Types.CREATE_EVALUATION_MODEL:
            return {
                ...state,
                _id: payload._id,
                modalEvaluationModel: true
            }

        case Types.CLOSE_EVALUATION_MODEL:
            return {
                ...state,
                _id:'',
                modalEvaluationModel: false
            }

        case Types.DELETE_EVALUATION_MODEL:
            return {
               ...state,
                _id: payload._id,
                eliminaModelEvaluation: true
            }

        case Types.CLOSE_DELETE_EVALUATION_MODEL:
            return {
               ...state,
                _id:'',
                eliminaModelEvaluation: false
            }
       
            case Types.OPEN_COLLABORATOR_PERFORMANCE_EVALUATION:
                return {
                    ...state,
                    _id: payload._id,
                    reload:payload.reload,
                    modalCollaboratorPerformanceEvaluation: true
                }    
    
            case Types.CLOSE_COLLABORATOR_PERFORMANCE_EVALUATION:
                    return {
                        ...state,
                        _id:'',
                        reload:payload.reload,
                        modalCollaboratorPerformanceEvaluation: false
                }
                
            case Types.OPEN_COLLABORATOR_EXTERN_PERFORMANCE_EVALUATION:
                    return {
                        ...state,
                        _id: payload._id,
                        idUser:payload.idUser,
                        typeEval: payload.typeEval,
                        typeArray: payload.typeArray,
                        infoEvalExt:payload.infoEvalExt,
                        modalCollaboratorExternoPerformanceEvaluation: true
                    }    
        
            case Types.CLOSE_COLLABORATOR_EXTERN_PERFORMANCE_EVALUATION:
                        return {
                            ...state,
                            _id: payload._id,
                            infoEvalExt: null,
                            modalCollaboratorExternoPerformanceEvaluation: false
                    } 
                    
            case Types.OPEN_COLLABORATOR_ADD_PERFORMANCE_EVALUATION:
                        return {
                            ...state,
                            _id: payload._id,
                            modalCollaboratorAddPerformanceEvaluation: true
                        }    
            
            case Types.CLOSE_COLLABORATOR_ADD_PERFORMANCE_EVALUATION:
                            return {
                                ...state,
                                _id: payload._id,
                                modalCollaboratorAddPerformanceEvaluation: false
                        }         


        default:
        return state;
    }
}

export default ModalReducer;